import { render, staticRenderFns } from "./TrustBackToMaestro.vue?vue&type=template&id=96b9fcb4&scoped=true"
import script from "./TrustBackToMaestro.vue?vue&type=script&lang=js"
export * from "./TrustBackToMaestro.vue?vue&type=script&lang=js"
import style0 from "./TrustBackToMaestro.vue?vue&type=style&index=0&id=96b9fcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b9fcb4",
  null
  
)

export default component.exports